import { ApiError, NetworkError } from "@brandex/api-client";
import type { MessageKey } from "@brandex/i18n";

type T = (key: MessageKey, vars?: Record<string, string | number>) => string;

const KNOWN: Record<string, MessageKey> = {
  unauthenticated: "error.unauthenticated",
  mfa_required: "error.mfa_required",
  email_taken: "error.email_taken",
  validation_failed: "error.validation_failed",
  article_pins_full: "error.article_pins_full",
  social_pins_full: "error.social_pins_full",
};

/** Maps any thrown error to a localized, user-safe message. */
export function errorMessage(error: unknown, t: T): string {
  if (error instanceof ApiError) {
    if (error.code === "rate_limited") {
      return t("error.rate_limited", { seconds: error.retryAfterSeconds ?? 60 });
    }
    const key = KNOWN[error.code];
    if (key !== undefined) return t(key);
    // Server validation messages are precise and already user-facing.
    if (error.status === 422) return error.message;
    return t("common.error");
  }
  if (error instanceof NetworkError) return t("error.network");
  return t("common.error");
}

/** The field a server validation error refers to, if any. */
export function errorField(error: unknown): string | undefined {
  return error instanceof ApiError ? error.field : undefined;
}
